window.Shopify = window.Shopify || {};
window.Shopify.pubsub = (() => {
  const subscribers = Object.create(null); // proto-safe

  function subscribe(eventName, callback) {
    if (typeof callback !== 'function') {
      console.error(`Invalid callback for "${eventName}"`, callback);
      return () => {};
    }
    const list = subscribers[eventName] || (subscribers[eventName] = []);
    if (!list.includes(callback)) list.push(callback); // dedupe
    return function unsubscribe() {
      const i = list.indexOf(callback);
      if (i > -1) list.splice(i, 1);
    };
  }

  function publish(eventName, data) {
    const list = subscribers[eventName];
    if (!list || list.length === 0) return Promise.resolve();
    const snapshot = list.slice(); // stable if list mutates during publish
    return Promise.all(
      snapshot.map((cb) => {
        try { return cb(data); }
        catch (e) { console.error(`Error in subscriber for "${eventName}":`, e); }
      })
    );
  }

  return { subscribe, publish };
})();
